import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/sequence-toolbar/sequence-toolbar.js';
      import {SequenceToolbarType} from '@oicl/openbridge-webcomponents/dist/components/sequence-toolbar/sequence-toolbar.js';

      export interface Props {
     type?: SequenceToolbarType;
     hasAdd?: boolean
   }

      
  
      export type {SequenceToolbarType} from '@oicl/openbridge-webcomponents/dist/components/sequence-toolbar/sequence-toolbar.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSequenceToolbar',
  props: {
    type: {},
    hasAdd: { type: Boolean }
  },
  emits: ["prev-click", "next-click", "add-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onPrevClick: (event: CustomEvent<unknown>) => emit('prev-click', event as CustomEvent<unknown>),
onNextClick: (event: CustomEvent<unknown>) => emit('next-click', event as CustomEvent<unknown>),
onAddClick: (event: CustomEvent<unknown>) => emit('add-click', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-sequence-toolbar',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})